import { SignUpButton } from "@clerk/clerk-react";
import React from "react";
import EnhancedSignIn from "../../features/auth/components/EnhancedSignIn";
import useRememberedUser from "../../features/auth/hooks/useRememberedUser";
import Button from "../atoms/Button";
import WelcomeMessage from "../molecules/WelcomeMessage";

/**
 * WelcomePanel - Welcome component for non-authenticated users
 */
const WelcomePanel = () => {
  const { rememberedUser } = useRememberedUser();

  // Function to create a test user (dev only)
  const createTestUser = () => {
    const testUser = {
      id: "test123",
      email: "test@example.com",
      firstName: "Test",
      lastName: "User",
      imageUrl:
        "https://ui-avatars.com/api/?name=Test+User&background=4db1e0&color=fff",
      lastSignIn: new Date().toISOString(),
    };

    localStorage.setItem("rememberedUser", JSON.stringify(testUser));
    console.log("Created test user in localStorage");
    // Force refresh
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-[#0f1418] flex flex-col items-center justify-center p-4">
      <div className="animate-in fade-in duration-500 slide-in-from-bottom-4 flex flex-col items-center">
        <div className="text-[#4db1e0] text-5xl mb-4">🔐</div>
        <h1 className="text-2xl font-bold text-white mb-4">
          Welcome to ELITA Kanban
        </h1>

        {/* Show welcome back message if there's a remembered user */}
        {rememberedUser && <WelcomeMessage user={rememberedUser} />}

        <p className="text-gray-300 mb-8 text-center max-w-md">
          Please sign in to access your Kanban dashboard and manage your tasks
          with real-time updates.
        </p>

        <div className="flex flex-col space-y-4 items-center">
          <EnhancedSignIn>
            <Button variant="primary">Sign In</Button>
          </EnhancedSignIn>

          <SignUpButton mode="modal">
            <Button variant="secondary">Sign Up</Button>
          </SignUpButton>

          {/* Dev only button */}
          <button
            onClick={createTestUser}
            className="mt-8 text-xs text-gray-500 hover:text-[#4db1e0] transition-colors duration-200 underline-offset-2 hover:underline"
          >
            Create Test User (Dev Only)
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePanel;
